import React, { useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import { getTotalPages } from "../../utils/helpers/getTotalPages";
import { getEnvVariables } from "../../utils/helpers/getEnvVariables";
import { useNotifyHandler } from "@Hooks";

const SelectAsyncPaginateBarrios = (props) => {
  const [itemsDonwload, setItemsDonwload] = useState({ results: [] });
  const { alertNotify } = useNotifyHandler();
  const { API_URL } = getEnvVariables();
  const getDefaultHood = async () => {
    let defaultHood = null;
    let page = 1;
    let lastPage = 999

    while (page <= lastPage) {
      if (!props.localidad) break

      const response = await fetch(
        `${API_URL}/utils/barrios/?localidad=${props.localidad}&page=${page}`
      );
      const responseData = await response.json();
      if (responseData?.results && lastPage === 999) {
        const totalItems = responseData.count
        const itemsPerPage = responseData?.results.length
        lastPage = getTotalPages(totalItems, itemsPerPage)
      }
      defaultHood = responseData.results?.filter(item => item.id === props.id)?.[0]
      if (defaultHood) break
      page++;
    }
    return defaultHood;
  };

  const printAlert = () => {
    if (!props.localidad) {
      alertNotify(
        "Debe seleccionar una localidad",
        "bottom",
        "center",
        "error"
      );
    }
  };

  const getDefaultValue = async () => {
    if (!props.localidad) return
    const defaultValue = await getDefaultHood()
    props.onChange(defaultValue)
  }

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    let resp = itemsDonwload;
    let nextHas = null;
    if (props.localidad && searchQuery.length == 0) {
      const response = await fetch(
        `${API_URL}/utils/barrios/?localidad=${props.localidad}&page=${page}`
      );
      resp = await response.json();
      setItemsDonwload({
        ...resp,
        results: [...resp.results, ...(itemsDonwload?.results || [])],
      });
      nextHas = resp.next;
    } else {
      resp = itemsDonwload;
    }
    return {
      options: resp.results,
      hasMore: nextHas !== null,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  return (

    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify(props.localidad)}
      value={props.value || getDefaultValue}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.nombre}
      getOptionLabel={(option) => option.nombre}
      onChange={onChange}
      onFocus={printAlert}
      isSearchable={true}
      placeholder="Seleccionar"
      additional={{
        page: 1,
      }}
      filterOption={(option, inputValue) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
    />
  );
};

SelectAsyncPaginateBarrios.propTypes = {
  localidad: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default SelectAsyncPaginateBarrios;